(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kb-slideshow"] && !Shopify.designMode) return;
  try {
    
function setupKBSliders(root){root.querySelectorAll('[data-kb-slider]').forEach(slider=>{if(slider.dataset.ready)return;slider.dataset.ready='true';const track=slider.querySelector('.kb-slides');slider.querySelector('.kb-prev').addEventListener('click',()=>{const i=Math.round(track.scrollLeft/track.clientWidth);track.scrollTo({left:(i>0?i-1:track.children.length-1)*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})});slider.querySelector('.kb-next').addEventListener('click',()=>{const i=Math.round(track.scrollLeft/track.clientWidth);track.scrollTo({left:(i<track.children.length-1?i+1:0)*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})})})}
setupKBSliders(document);document.addEventListener('shopify:section:load',()=>setupKBSliders(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
